module.exports = __webpack_public_path__ + "img/ph.c0c16a09.jpg";